/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Commit_SuccessInputs */

const cs_import_commit_success = /** @type {(inputs: Import_Commit_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import byl potvrzen.`)
};

const en_import_commit_success = /** @type {(inputs: Import_Commit_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import committed.`)
};

/**
* | output |
* | --- |
* | "Import committed." |
*
* @param {Import_Commit_SuccessInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_commit_success = /** @type {((inputs?: Import_Commit_SuccessInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Commit_SuccessInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_commit_success(inputs)
	return cs_import_commit_success(inputs)
});